import { type DieCreation, DieMaterial, type Die } from '../die.type';
import { Modifier } from '../modifier';
import { ModifierPriority, ModifierTags, StatusEffect } from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Petrified extends Modifier {
  static readonly baseTitle = 'Petrified';
  static readonly baseText =
    'At the start of turn, give a number of die equal to stacks the stone material.';
  static readonly baseIcon = 'petrified';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Petrified.baseTitle;
  text = Petrified.baseText;
  icon = Petrified.baseIcon;
  tags: Array<ModifierTags> = [...Petrified.baseTags];
  priority = Petrified.basePriority;

  getDice(dice: Array<DieCreation>): Array<DieCreation> {
    // Clone dice array since we're modifying it
    dice = dice.map((die) => ({ ...die }));

    // Find indices of normal dice
    let normalIndices = dice
      .map((die, index) => (die.material === DieMaterial.Normal ? index : -1))
      .filter((index) => index !== -1);

    // Shuffle the indices
    normalIndices.sort(() => Math.random() - 0.5);

    // Take the first n indices where n is min(stacks, available normal dice)
    const numToChange = Math.min(this.stacks, normalIndices.length);
    for (let i = 0; i < numToChange; i++) {
      dice[normalIndices[i]].material = DieMaterial.Stone;
    } // Remove all stacks since effect is fully applied
    this.removeStacks(this.stacks);

    return dice;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Petrified, Petrified);
